import React from 'react';

const Export = (props) => {
     return (
        <button className='btn btn_primary_outline' onClick={ () => props.aacExportUsersAction(props.filteredWithSort) }>Export</button>
     )
}

export default Export;